module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-thumbs-up-339eb5fc01cc1614a62012654d78ba12.svg";